import React from 'react';
interface FooterProps {
  onNavigate: (page: string) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  return <footer className="bg-neutral-950 py-12 border-t border-neutral-900" data-id="element-95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center" data-id="element-96">
        <div className="mb-6 md:mb-0 text-center md:text-left" data-id="element-97">
          <span className="text-xl font-bold text-white tracking-tight" data-id="element-98">
            Areál <span className="text-[#e0a812]" data-id="element-99">Žlutice</span>
          </span>
          <p className="text-neutral-500 text-sm mt-2" data-id="element-100">
            © {new Date().getFullYear()} Areál Žlutice. Všechna práva
            vyhrazena.
          </p>
        </div>

        <nav className="flex flex-wrap justify-center gap-6" data-id="element-101">
          <a href="#uvod" onClick={e => {
          e.preventDefault();
          onNavigate('home');
        }} className="text-sm text-neutral-400 hover:text-[#e0a812] transition-colors" data-id="element-102">
            Úvod
          </a>
          <a href="#o-objektu" onClick={e => {
          e.preventDefault();
          onNavigate('home');
          setTimeout(() => {
            const el = document.getElementById('o-objektu');
            if (el) el.scrollIntoView({
              behavior: 'smooth'
            });
          }, 100);
        }} className="text-sm text-neutral-400 hover:text-[#e0a812] transition-colors" data-id="element-103">
            O objektu
          </a>
          <button onClick={() => onNavigate('gallery')} className="text-sm text-neutral-400 hover:text-[#e0a812] transition-colors" data-id="element-104">
            Galerie
          </button>
          <a href="#kontakt" onClick={e => {
          e.preventDefault();
          onNavigate('home');
          setTimeout(() => {
            const el = document.getElementById('kontakt');
            if (el) el.scrollIntoView({
              behavior: 'smooth'
            });
          }, 100);
        }} className="text-sm text-neutral-400 hover:text-[#e0a812] transition-colors" data-id="element-105">
            Kontakt
          </a>
        </nav>
      </div>
    </footer>;
}